import { ThemeMode, ThemeTokens } from './theme.types';

/** Light values reference styles.css, the existing CMS design source. */
const light: ThemeTokens = {
  background: 'var(--aw-cms-color-standard-background)',
  surface: 'var(--aw-cms-color-standard-surface)',
  'surface-raised': 'var(--aw-cms-color-primary-on)',
  'text-primary': 'var(--aw-cms-color-standard-text-primary)',
  'text-secondary': 'var(--aw-cms-color-standard-text-secondary)',
  'text-disabled': 'var(--aw-cms-color-standard-text-disabled)',
  border: 'var(--aw-cms-color-standard-outline-light)',
  divider: 'var(--aw-cms-color-standard-divider)',
  hover: 'var(--aw-cms-color-standard-hover-main)',
  selected: 'var(--aw-cms-color-standard-selected)',
  link: 'var(--aw-cms-color-primary-main)',
  'focus-ring': 'var(--aw-cms-color-input-focus)',
  'control-background': 'var(--aw-cms-color-primary-on)',
  'control-text': 'var(--aw-cms-color-standard-text-primary)',
  'control-border': 'var(--aw-cms-color-input-ring)',
  'control-placeholder': 'var(--aw-cms-color-input-label)',
  'disabled-background': 'var(--aw-cms-color-standard-disabled)',
  'disabled-border': 'var(--aw-cms-color-background-disabled)',
  'disabled-text': 'var(--aw-cms-color-standard-text-disabled)',
  'action-background': 'var(--aw-cms-color-primary-main)',
  'action-text': '#FFFFFF',
  'action-border': 'var(--aw-cms-color-primary-main)',
  'action-outline': 'var(--aw-cms-color-primary-main)',
  'action-hover-background': 'var(--aw-cms-color-primary-hover)',
  'action-active-background': 'var(--aw-cms-color-info-dark)',
  'secondary-background': 'var(--aw-cms-color-secondary-main)',
  'secondary-text': 'var(--aw-cms-color-secondary-on)',
  'secondary-border': 'var(--aw-cms-color-secondary-dark)',
  'secondary-outline': 'var(--aw-cms-color-secondary-main)',
  'secondary-hover-background': 'var(--aw-cms-color-secondary-hover)',
  error: 'var(--aw-cms-color-error-main)',
  'error-background': 'var(--aw-cms-color-error-light)',
  'on-error': 'var(--aw-cms-color-error-on)',
  'error-hover': 'var(--aw-cms-color-error-hover)',
  success: 'var(--aw-cms-color-success-main)',
  'control-radius': 'var(--aw-cms-radius-input)',
  'button-radius': 'var(--aw-cms-radius-md)',
};

export const CMS_DARK_PALETTE = {
  primaryFill: '#769FC7',
  primaryContrast: '#121212',
  primaryBorder: '#769FC7',
  primaryOutline: '#769FC7',
  secondaryFill: '#74BC47',
  secondaryContrast: '#333333',
  secondaryBorder: '#46722C',
  secondaryOutline: '#74BC47',
  primary: '#769FC7',
  link: '#FFE556',
  footerBackground: '#253359',
  footerContrast: '#FFFFFF',
} as const;

const dark: ThemeTokens = {
  ...light,
  background: '#121212',
  surface: '#1E1E1E',
  'surface-raised': '#272727',
  'text-primary': '#F5F5F5',
  'text-secondary': '#C5CACF',
  'text-disabled': '#999999',
  border: '#64696E',
  divider: '#383838',
  hover: '#2E2E2F',
  selected: '#254767',
  link: CMS_DARK_PALETTE.link,
  'focus-ring': CMS_DARK_PALETTE.primaryOutline,
  'control-background': '#1E1E1E',
  'control-text': '#F5F5F5',
  'control-border': '#64696E',
  'control-placeholder': '#C5CACF',
  'disabled-background': '#2F2F30',
  'disabled-border': '#383838',
  'disabled-text': '#999999',
  'action-background': CMS_DARK_PALETTE.primaryFill,
  'action-text': CMS_DARK_PALETTE.primaryContrast,
  'action-border': CMS_DARK_PALETTE.primaryBorder,
  'action-outline': CMS_DARK_PALETTE.primaryOutline,
  'action-hover-background': '#9CC4EC',
  'action-active-background': '#BAD8F3',
  'secondary-background': CMS_DARK_PALETTE.secondaryFill,
  'secondary-text': CMS_DARK_PALETTE.secondaryContrast,
  'secondary-border': CMS_DARK_PALETTE.secondaryBorder,
  'secondary-outline': CMS_DARK_PALETTE.secondaryOutline,
  'secondary-hover-background': '#A5D387',
  error: '#FFB4AB',
  'error-background': '#4A2020',
  'on-error': '#121212',
  'error-hover': '#FFDAD6',
  success: '#A5D387',
};

export const CMS_THEMES: Readonly<Record<ThemeMode, ThemeTokens>> = {
  light,
  dark,
};
